import React from 'react';
import {theme, Typography} from 'antd';
import {labelStyle} from './gridHelpers';

// Field label with a red asterisk when the field config marks it `required`
// (the old MUI fields showed one via `required={field.required}`).
const FieldLabel: React.FC<{field: any}> = ({field}) => {
  const {token} = theme.useToken();
  return (
    <Typography.Text style={labelStyle}>
      {field?.fieldLabel}
      {field?.required ? <span style={{color: token.colorError, marginLeft: 2}}>*</span> : null}
    </Typography.Text>
  );
};

export default FieldLabel;
